import React from 'react';
import './Fulfillment.css';
import Helmet from "react-helmet/es/Helmet";
import FaqButtonService from "../faq-button-service/faq-button-service";
import {DateTime} from 'luxon';
import ReactHtmlParser from 'react-html-parser';

class Fulfillment extends React.Component {    

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;     
        this.state = {
        	showConfirmationPopup: false,
            termesAndConditionsAccepted: false,
            
        }

        window.dataLayer = window.dataLayer || [];
        try {
			var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/fulfillment',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
				window.dataLayer.push({
					'event': 'VirtualPageview',
					'virtualPageURL': 'gaVirtualPageURL',
					'virtualPagePath': '/css/guest/fulfillment',
					'virtualPageTitle': 'Customer Self Service'
	
				});
			} else {
				console.log("off");    
			}
          
        } catch (error) {
            //swallow error
        }
    }
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }
    getFormattedDate = (dateToFormat) => {
    	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
    	return formattedDate;
    }
    
    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
    	 document.getElementById("ajaxLoadText").innerHTML = "loading";
    	 document.getElementById("ajaxShim").style.display = "block";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
    	 document.getElementById("ajaxSpinner").style.display = "block";
     }	
     
     ajaxSpinnerHide = () => {
    	 document.getElementById("ajaxSpinner").style.display = "none";
    	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
    	 document.getElementById("ajaxShim").style.display = "none";
     }
    
    handleChangeBonusRedeem = (radioButtonBonusRedeem1, radioButtonBonusRedeem2, value1, value2) => {
    	if(document.getElementById('redeemChoiceOption_' + radioButtonBonusRedeem1 + "_" + radioButtonBonusRedeem2).checked===true){
    		this.props.CallTracker('Customer Self Service', 'Bonus Offer Click', value1 + " - " + value2);
		}
    }

	showTAndC=(elementId)=>{
		let c=document.getElementById(elementId);
	  if(c.style.display==='none'){
		  c.style.display='block';
	  }else{
		  c.style.display='none';
	  }}

    getCookie= (cname) => {
    	  let name = cname + "=";
    	  let decodedCookie = decodeURIComponent(document.cookie);
    	  let ca = decodedCookie.split(';');
    	  for(let i = 0; i <ca.length; i++) {
    	    let c = ca[i];
    	    while (c.charAt(0) === ' ') {
    	      c = c.substring(1);
    	    }
    	    if (c.indexOf(name) === 0) {
    	      return c.substring(name.length, c.length);
    	    }
    	  }
    	  return "";
    	}
	
	descriptionContainVisa = (promo) => {       
		return promo.description.toLocaleLowerCase().includes("visa");
	}

    render = () => {
        return (
            <div className="rea-appContainer" id="mainContent" tabindex="-1">
                <Helmet>
                    <title>Customer Self Service / Redeem Bonus Offers</title>
                </Helmet>                
                <div class="wth2-css_heading">
            		<h1 class="wth2-pageTopH1" id="css_title_visible">Redeem Bonus Offer</h1>
	            </div>
	            <div class="wth2-css_tripToolsHeading">
		        	<div id="css_tripTools">
						{this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y' ?
							<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" href="# " id="css_tripTools_bookingSummary" onClick={e => {e.preventDefault(); this.props.onChangeView('new-summary', this.booking, this.booking.hash, this.state.updatedBooking)} }>Return to Booking Summary</a>
							:
							<a class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" href="# " id="css_tripTools_bookingSummary" onClick={e => {e.preventDefault(); this.props.onChangeView('summary-swap', this.booking, this.booking.hash, this.state.updatedBooking)} }>Return to Booking Summary</a>
						}
		            </div>
	            </div>
	            <form name="cssFulfillment" id="cssFulfillment" class="wth2-form wth2-cssFulfillment_Form" onSubmit={this.fulfillmentFormSubmit} novalidate>
		    		<div id="message" class="wth2-errorMessage wth2-errorMessageHeader" style={{ display: 'none' }}></div>
		    		<div id="message2" class="wth2-sucessMessage" style={{ display: 'none' }}><div class="wth2-sucessMessageCont"><span class="wth2-sucessMessageHeader"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Submission received!</span><br />We&#39;ve added your selection  to your reservation. Shortly, you will receive an email with an updated booking confirmation that reflects your bonus offer selection and any additional steps you may need to take.</div></div>
		    		<div id="message3" class="wth2-errorMessage" style={{ display: 'none' }}><i class="fa fa-exclamation-circle" aria-hidden="true"></i><span class="wth2-errorMessageHeader">Submission failed.</span><br />We&#39;re sorry, something appears to have gone wrong. Please try again later, or call us at <span id="css_fulfillmenterrorPhone">{this.props.siteConfigData.cruisePhone}</span> for assistance</div>
		    		<div id="cssFulfillmentFormError" class="wth2-errorMessage" style={{ display: 'none' }}>
		    			<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
		    			<div class="wth2-errorMessageHeader"> Please select your bonus offer. </div>
		    			<div id="choice_cssFulfillmentErrorMessage_required" class="wth2-formErrorMessage wth2-errorMessageTextOR" style={{ display: 'none' }}> Please Choose your Reward </div>					
		    		</div>
		    		<div id="css_fulfillmentGroupContainerHolder">
		    		
			    		{this.props.bonusOffers.bonusOffers.map((redeemablePromo, index, arr)=>(	
		    				<div>
				    			{redeemablePromo.childPromotions.length>1 &&
				    			<div class="wth2-css_fulfillmentGroupContainer">
				    				<div>
				    					<div class="form-group">
				    						<div id={"css_redeemChoice_" + redeemablePromo.parentPromotionId} class="wth2-redeemChoiceHead wth2-bold">{redeemablePromo.parentPromotionDescription}</div> 
				    						<div id={"redeemChoiceSubheader_" + redeemablePromo.parentPromotionId} class="wth2-redeemChoiceSubheader">Savvy cruisers like you know {this.props.siteConfigData.endorsement} always gives you MORE!</div>
				    						<div id="redeemChoiceSubheader_{{redeemablePromo.parentPromotionId}}" class="wth2-redeemChoiceSubheader">Take your cruise vacation to the next level by selecting ONE of these {this.props.siteConfigData.endorsement} bonus offers below.  Your choice will be added to your reservation.</div>
				    						<div id={"wth2-redeemChoiceContainer_" + index} class="formRadioBonus">
				    						
					    						<div class="wth2-css_radioBtn">
					    				   			<fieldset class="wth2-radioBtn wth2-radioBtnVertical">
					    				   			{redeemablePromo.childPromotions.map((childPromo, index, arr)=>(	
					    				   				<div class="wth2-fulfillmentInputContainer form-group" id={"redeemGroup_" + redeemablePromo.parentPromotionId}>
					    									<label class for={"redeemChoiceOption_" + redeemablePromo.parentPromotionId + "_" + childPromo.promotionId} id={"redeemChoiceLabel_" + redeemablePromo.parentPromotionId + "_" + childPromo.promotionId}>
																<input type="radio" class="form-control wth2-fulfillmentChoiceRadio" id={"redeemChoiceOption_" + redeemablePromo.parentPromotionId + "_" + childPromo.promotionId} name={redeemablePromo.parentPromotionId} value={childPromo.promotionId} onClick={() => { this.handleChangeBonusRedeem(redeemablePromo.parentPromotionId, childPromo.promotionId, redeemablePromo.parentPromotionDescription, childPromo.description)} } />
																<span></span>{childPromo.description}
																{
																	this.descriptionContainVisa(childPromo) ? <img className='child-promo-recommended-badge' src="/includes/global/css/images/recommended-badge.png" alt="Recommended" /> : null
																}																
															</label>
															 <div id="redeemChoiceOptionDescription" class="wth2-redeemChoiceOptionDescription "dangerouslySetInnerHTML={{__html: childPromo.promoDisclaimerDesc}}>                                                            
                                                             </div>
					    								</div>
					    								
					    				   			))}	    								
					    							</fieldset>
					    							<div id={"css_redeemBonusOfferTandCContainer_" + redeemablePromo.parentPromotionId} class="wth2-css_redeemBonusOfferTandCContainer">
													<a  id={"css_redeemBonusOfferTandCHead_" + redeemablePromo.parentPromotionId} tabIndex="0" class="wth2-css-TandC-Link"  onKeyDown={e =>{if((e.key==="Enter")||(e.key==="Escape")){this.showTAndC("css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId)}}}  onClick={e=>{e.preventDefault();this.showTAndC("css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId)}} href="# ">Terms & Conditions</a>
					    								<div class="wth2-css-TandC" style={{display:"none"}} id={"css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId}>{ReactHtmlParser(redeemablePromo.parentPromotionTermsAndConditions)}</div>
					    							</div>
					    						</div>	
				    						</div>
				    					</div>					
				    					<div style={{ clear: 'both' }}></div>	
				    				</div>
				    			</div>
				    			}
			    			</div>
		        				 
	    		        ))}
			    		
			    		{this.props.bonusOffers.bonusOffers.map((redeemablePromo, index, arr)=>(	
			    			redeemablePromo.childPromotions.length===1 &&
					    		<div>
			    					<div class="form-group">
			    						<div id={"css_redeemChoice_" + redeemablePromo.parentPromotionId} class="wth2-redeemChoiceHead wth2-bold">{redeemablePromo.parentPromotionDescription}</div> 
			    						<div id={"redeemChoiceSubheader_" + redeemablePromo.parentPromotionId} class="wth2-redeemChoiceSubheader">Savvy cruisers like you know {this.props.siteConfigData.endorsement} always gives you MORE!</div>
			    						<div id={"redeemChoiceSubheader_" + redeemablePromo.parentPromotionId} class="wth2-redeemChoiceSubheader">Take your cruise vacation to the next level redeeming the {this.props.siteConfigData.endorsement} bonus offers below.  This will add the offer to your reservation.</div>
			    						<input type="hidden" name={redeemablePromo.parentPromotionId} id={"redeemChoiceOption_" + redeemablePromo.parentPromotionId + "_" + redeemablePromo.childPromotions[0].promotionId} value={redeemablePromo.childPromotions[0].promotionId} checked="true"/><label for={"redeemChoiceOption_" + redeemablePromo.parentPromotionId + "_" + redeemablePromo.childPromotions[0].promotionId} id={"redeemChoiceLabel_" + redeemablePromo.parentPromotionId + "_" + redeemablePromo.childPromotions[0].promotionId}>{redeemablePromo.childPromotions[0].description}</label>
			    					</div>					
			    					<div style={{ clear: 'both' }}></div>	
			    					<div id={"css_redeemBonusOfferTandCContainer_" + redeemablePromo.parentPromotionId} class="wth2-css_redeemBonusOfferTandCContainer">
									<a id={"css_redeemBonusOfferTandCHead_" + redeemablePromo.parentPromotionId} tabIndex="0" onKeyDown={e =>{if((e.key==="Enter")||(e.key==="Escape")){this.showTAndC("css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId)}}} onClick={e=>{e.preventDefault();this.showTAndC("css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId)}} class="wth2-css-TandC-Link" href="# ">Terms & Conditions</a>
			    						<div class="wth2-css-TandC" style={{display:"none"}} id={"css_redeemBonusOfferTandCBody_" + redeemablePromo.parentPromotionId}>{ReactHtmlParser(redeemablePromo.parentPromotionTermsAndConditions)}</div>
			    					</div>
		    					</div>
			    		))}			
		    			<div class="wth2-cssfulfillmentbutton">
		    				<button id="cssfulfillmentButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" type="submit" ng-click="trackfulfillmentVal()"> Redeem Now </button>
		    			</div>	
		    		</div>
		    	</form>	
		    	{this.getStoreAttValue("HLP")!==''&&this.getStoreAttValue("HLP")!==null &&
            		<div id="css_faqContainer" className="wth2-cssLogin_cssFAQcontainer"><h2 id="wth2-cssLogin_cssFAQtitle" className="wth2-cssLogin_faqTitle">Looking for Answers? Visit our <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth2-cssLogin_helpLink" target="_blank" rel="noopener noreferrer" onclick="CallTracker('BCSS Login', 'Help Center Home', '')">Help Center</a><br />or click on one of the categories below.</h2><div id="faqButtonContainerWrapper"><FaqButtonService siteConfigData={this.siteConfigData}></FaqButtonService></div></div>
        		}
	         </div>
	            
	            
        );
    }
    fulfillmentFormIsValid = () => {
    	let fulfillmentFormState = false;
    	//radio button group exists
    	if(document.querySelector(".formRadioBonus")){
    		
    		let radioList = document.getElementsByClassName("formRadioBonus");
    		for (let i = 0; i < radioList.length; i++) {
    			let val=0;
    			let radioListName=radioList.item(i).getElementsByTagName("input")[0].getAttribute("name");
    			let radiosFulfillment = document.getElementsByName(radioListName);
    			for (let i1=0, len=radiosFulfillment.length; i1<len; i1++) {
    				if ( radiosFulfillment[i1].checked ) { 	
    					document.getElementById(radioList[i].id).classList.remove("has-error-radio-group");
    					val=0;					
    					break; // and break out of for loop
    				}
    				else{
    					val++;
    					document.getElementById(radioList[i].id).classList.add("has-error-radio-group");			
    					
    				}							
    			}
    			if (val>0)
    				{
    					for (let i2=0, len=radiosFulfillment.length; i2<len; i2++) {
    						radiosFulfillment[i2].setAttribute("aria-invalid", "true");
    					}
    					document.querySelector("#cssFulfillmentFormError").style.display="block";
    					document.querySelector("#cssFulfillmentFormError").setAttribute("aria-live", "assertive");
    					document.querySelector("#cssFulfillmentFormError").scrollIntoView();
    					fulfillmentFormState = false;
    				}
    				else{
    					for (let i2=0, len=radiosFulfillment.length; i2<len; i2++) {
    						radiosFulfillment[i2].setAttribute("aria-invalid", "false");
    					}
    					fulfillmentFormState = true;
    					//document.getElementById("cssFulfillmentFormError").style.display="none";
    				}
    		}
    		
    	}
    	//no radio button form group available - only hidden field forms always valid
    	else{    		
    		fulfillmentFormState = true;
    	}
    	return fulfillmentFormState;
    }
    
    fulfillmentFormSubmit = (event) => {
        event.preventDefault();
        if (this.fulfillmentFormIsValid()) {
        	this.ajaxSpinnerShow();
			document.querySelector("#cssFulfillmentFormError").style.display="none";
        	console.debug('Submit bonus offers redeem...');
        	
        	//gather child id values for submission
        	let chosenChildIds = "";
			let fulfillmentForm=document.getElementById("cssFulfillment");
			let valueFulfillments = fulfillmentForm.getElementsByTagName("input");
			for(let j=0; j<valueFulfillments.length; j++){		
				if(valueFulfillments[j].checked === true){
					chosenChildIds = chosenChildIds + "," + valueFulfillments[j].value;
				}
			}
			chosenChildIds = chosenChildIds.substring(1, chosenChildIds.length);
			
			//gather child id descriptions for tracking
			let chosenChildDescriptions = "";
			let descriptionFulfillments = fulfillmentForm.getElementsByTagName("input");
			for(let j=0; j<descriptionFulfillments.length; j++){		
				if(descriptionFulfillments[j].checked === true){
					let gatherID = descriptionFulfillments[j].id;
					gatherID = gatherID.replace("Option", "Label");
					chosenChildDescriptions = chosenChildDescriptions + "," + document.getElementById(gatherID).innerHTML;
				}
			}
			chosenChildDescriptions = chosenChildDescriptions.substring(1, chosenChildDescriptions.length);
			this.props.CallTracker("Customer Self Service", "Bonus Offer Attempt", chosenChildDescriptions);
			let url = '/wthrest/customer-self-service/applyBonusOffers.rs';
            let payload = {
                "bookingNumber": this.props.booking.bookingNumber,
                "bonusOfferIds": chosenChildIds,
                "sessionId": this.getCookie("WDVID")
            };
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(jsonBonusOfferSubmitResponse => jsonBonusOfferSubmitResponse.json()).then(jsonBonusOfferSubmitResponse => {

            	if(jsonBonusOfferSubmitResponse===''||jsonBonusOfferSubmitResponse===null) {
            		this.ajaxSpinnerHide();
                    let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                   	 this.setState({
                            'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                        });
                    this.setState({accessReservationBookingDisabled: false});
                } else {            
                	if(jsonBonusOfferSubmitResponse.successful === 'Y'){
                		this.ajaxSpinnerHide();
    					//success
    					document.getElementById("message2").style.display="block";
    					document.getElementById("css_fulfillmentGroupContainerHolder").style.display="none";	

    					document.querySelector("#message2").scrollIntoView();					
    					this.props.CallTracker("Customer Self Service", "Bonus Offer Redeemed", "Bonus Offer Submission Success");
    				}
    				else{
    					this.ajaxSpinnerHide();
    					//soft fail
    					document.getElementById("message3").style.display="block";
    					document.getElementById("css_fulfillmentGroupContainerHolder").style.display="none";
    					document.querySelector("#message3").scrollIntoView();
    					this.props.CallTracker("Customer Self Service", "Errors", "Bonus Offer Submission Failed");
    				}
                }
            }).catch(error => {
            	this.ajaxSpinnerHide();
                this.setState({accessReservationBookingDisabled: false});
                this.setState({'showVerificationErrorMessage': true});
                let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                //TODO  make errors more specific
                this.setState({
                    'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                });
            });
        }
    }
        
   
}

export default Fulfillment;
